import React from 'react';

// Simple text loader. You can add CSS to make this a spinner.
const Loader = () => {
  return (
    <div style={{ padding: '4rem', textAlign: 'center', fontSize: '1.5rem' }}>
      Loading...
    </div>
  );
};

export default Loader;